import React from 'react';
import {
  Grid, SpacingName, Image,
} from '@doveit/lego';
import * as styles from './Stripe.style';
import LayoutWrapper from '../../layouts/layout-wrapper/LayoutWrapper';
import { StripeDirection } from './types';

export interface StripeProps {
  imageURL: string,
  imageAlt: string,
  direction?: StripeDirection,
  children: React.ReactNode,
}

const Stripe: React.FC<StripeProps> = ({
  imageURL,
  imageAlt,
  direction = StripeDirection.LEFT,
  children,
}) => (
  <div
    css={styles.base}
    $direction={direction}
  >
    <LayoutWrapper>
      <div css={styles.content}>
        <Grid
          addCSS={styles.grid(direction)}
          gutter={SpacingName.MEDIUM}
        >
          <Grid.Unit size={{ LG: 1 / 2 }}>
            <div
              css={styles.image}
              $direction={direction}
            >
              <div
                css={styles.imageWrapper}
                $direction={direction}
              >
                <Image
                  src={imageURL}
                  alt={imageAlt}
                  width="100%"
                  fit
                  lazyLoad
                  overflow
                />
              </div>
            </div>
          </Grid.Unit>
          <Grid.Unit size={{ LG: 1 / 2 }}>
            <div
              css={styles.info}
              $direction={direction}
            >
              {children}
            </div>
          </Grid.Unit>
        </Grid>
      </div>
    </LayoutWrapper>
  </div>
);

export default Stripe;
